var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _path7, _g3, _path8, _g4, _path9, _g5, _path0, _g6, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 43,
    viewBox: "0 0 90 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_491_3192)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.378 -0.0001297C17.6445 0.353975 17.8088 0.759187 17.8635 1.20821C18.3491 0.788391 18.9039 0.660622 19.5318 0.824897C19.2398 0.967268 19.0062 1.17535 18.8236 1.44549C20.8971 1.23011 22.518 1.97482 23.6898 3.68694C23.6752 3.71614 23.657 3.72344 23.6314 3.70154C22.4486 2.85096 21.1308 2.4859 19.6779 2.61002C21.8572 3.14665 23.1203 4.51926 23.4671 6.72785C22.748 5.86997 21.9376 5.11795 21.0322 4.46815C20.7694 4.28928 20.4956 4.1396 20.2072 4.02644C21.1965 5.25303 21.5652 6.64389 21.3133 8.20268C20.9227 6.81911 20.1853 5.65824 19.1011 4.72004C19.3092 5.77505 19.3493 6.83737 19.2179 7.90698C19.1777 8.21728 19.1157 8.52393 19.0244 8.82327C18.7835 7.85222 18.4951 6.89943 18.1556 5.96123C17.9694 5.45746 17.7139 4.99383 17.389 4.57402C17.0641 5.01574 16.8085 5.49761 16.6223 6.01964C16.2901 6.93958 16.0054 7.87778 15.7681 8.82327C15.4286 7.45431 15.4031 6.08535 15.6951 4.72004C14.6145 5.65459 13.8808 6.81546 13.4975 8.20268C13.2346 6.64024 13.6033 5.24937 14.6036 4.02644C14.0779 4.26737 13.5851 4.57402 13.1288 4.94273C12.479 5.47571 11.8912 6.06345 11.3582 6.71325C11.5919 4.82591 12.614 3.52631 14.4247 2.8181C14.6547 2.73049 14.892 2.66113 15.1329 2.61002C14.432 2.52606 13.7457 2.58447 13.0667 2.7889C12.3658 2.99698 11.716 3.30728 11.1209 3.71979C11.7123 2.75969 12.5483 2.07704 13.6289 1.66818C14.4028 1.42359 15.1877 1.35423 15.9871 1.46009C15.8046 1.1863 15.571 0.97457 15.2789 0.824897C15.8886 0.667923 16.4398 0.784741 16.929 1.179C17.0093 0.759187 17.159 0.364926 17.3707 -0.0001297L17.378 -0.0001297Z",
    fill: "#28673C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0635368 6.58214C5.49192 7.64445 10.913 8.72502 16.3304 9.82749C16.4144 11.6017 16.4765 13.3722 16.5239 15.1391C14.8191 14.2593 13.0595 13.5182 11.2452 12.9122C9.33596 12.2843 7.38656 12.1383 5.40431 12.4705C6.58709 12.507 7.75527 12.6421 8.91614 12.883C10.3216 13.2809 11.676 13.8029 12.9865 14.4491C14.0196 14.9638 15.0308 15.5114 16.0238 16.0882C14.4066 17.0885 12.7638 18.0522 11.0992 18.9794C11.3693 19.3116 11.6541 19.6329 11.9534 19.9395C11.9826 19.9578 12.0118 19.9578 12.041 19.9395C13.5451 18.9685 15.0637 18.0157 16.5969 17.0921C16.7247 19.8884 16.8269 22.6811 16.9072 25.4738C15.2681 23.6595 13.6181 21.8488 11.968 20.0418C11.4606 20.3703 10.924 20.6514 10.3618 20.8814C9.25565 21.2391 8.13492 21.2975 6.9996 21.0603C6.59804 20.958 6.19283 20.8595 5.79127 20.7646C7.71146 20.6733 9.45278 20.0746 11.0116 18.9648C7.3318 14.9237 3.67029 10.8752 0.0160795 6.81943C-0.00947437 6.73181 0.00512787 6.6515 0.0598863 6.58214H0.0635368Z",
    fill: "#28673C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.543 6.58222C34.7474 6.53841 34.8314 6.61507 34.7949 6.8195C31.1224 10.8607 27.4609 14.9091 23.8067 18.9649C25.3655 20.082 27.1032 20.6807 29.027 20.7646C28.4028 20.9289 27.7749 21.0676 27.1397 21.1772C25.8547 21.3013 24.6427 21.0567 23.511 20.4397C23.2847 20.3083 23.0583 20.1732 22.832 20.0418C21.1893 21.8525 19.5465 23.6632 17.9074 25.4739C17.8965 25.4191 17.8892 25.3643 17.8782 25.3132C17.9804 22.5717 18.0936 19.8337 18.2177 17.0922C19.7436 18.0304 21.2623 18.9795 22.7736 19.9396C22.8028 19.9579 22.832 19.9579 22.8612 19.9396C23.1387 19.6184 23.4234 19.3044 23.7154 18.9941C22.0544 18.0559 20.4117 17.0849 18.7908 16.0883C20.6745 14.9493 22.6495 14.0002 24.7194 13.2408C25.4568 12.9743 26.2124 12.7882 26.99 12.6786C27.7931 12.5764 28.5999 12.5071 29.4103 12.4706C27.4609 12.142 25.5407 12.2807 23.657 12.8831C21.8099 13.4964 20.0211 14.2484 18.2871 15.1428C18.3199 13.3723 18.3856 11.6017 18.4805 9.83121C23.8359 8.747 29.1913 7.66278 34.543 6.58587V6.58222Z",
    fill: "#28673C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5266 13.1163H74.6883V17.2268H70.5266V13.1163ZM74.6883 6.78986H76.8494V19.3879H74.6883C74.6956 18.7016 74.6883 18.019 74.6627 17.3327C73.9874 18.008 73.312 18.687 72.633 19.3624C71.2275 19.3879 69.8221 19.3989 68.4203 19.3879C68.413 17.2633 68.4203 15.135 68.4458 13.0104C69.1212 12.3351 69.7965 11.6561 70.4755 10.9807C71.881 10.9551 73.2864 10.9442 74.6883 10.9551V6.78986Z",
    fill: "#28673C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_491_3192",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 6,
    width: 4,
    height: 3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2991 6.69531H77.9445V8.95501H80.2991V6.69531Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_491_3192)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0614 6.79102H80.2226V8.90104H78.0614V6.79102Z",
    fill: "#28673C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_491_3192",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 8,
    width: 9,
    height: 12
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9115 8.76474H39.3436V19.4974H47.9115V8.76474Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_491_3192)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4499 8.84529H47.8238V11.0064H41.5558V13.0617H47.8238C47.8311 14.4672 47.8238 15.8726 47.7983 17.2781C47.1046 17.9717 46.411 18.6653 45.7174 19.3589C43.6111 19.3845 41.5047 19.3954 39.3947 19.3845V17.2233H45.6627V15.1681H39.3947C39.3874 13.7443 39.3947 12.3206 39.4202 10.8969C40.1065 10.2179 40.7819 9.5316 41.4499 8.84164V8.84529Z",
    fill: "#28673C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_491_3192",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 10,
    width: 9,
    height: 10
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5158 10.8349H49.0429V19.4976H57.5158V10.8349Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_491_3192)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1969 13.1162H55.3585V17.2267H51.1969V13.1162ZM51.1421 10.9551H57.4649V19.3879H55.3585C55.3658 18.7015 55.3585 18.0189 55.333 17.3326C54.6576 18.0079 53.9823 18.6869 53.3033 19.3623C51.8978 19.3879 50.4923 19.3988 49.0905 19.3879C49.0832 17.2632 49.0905 15.1349 49.1161 13.0103C49.8024 12.3313 50.4777 11.645 51.1458 10.9551H51.1421Z",
    fill: "#28673C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_491_3192",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 10,
    width: 10,
    height: 10
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2118 10.8349H58.6439V19.4976H67.2118V10.8349Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_491_3192)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7278 10.9551H60.8889V17.2267H64.9995V10.9551H67.1606C67.1679 13.0651 67.1606 15.1715 67.1351 17.2815C66.4414 17.9751 65.7478 18.6687 65.0542 19.3623C62.9479 19.3879 60.8415 19.3988 58.7315 19.3879V10.9551H58.7278Z",
    fill: "#28673C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_491_3192",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 10,
    width: 4,
    height: 10
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2991 10.8349H77.9445V19.4976H80.2991V10.8349Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_491_3192)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0614 10.9551H80.2226V19.3879H78.0614V10.9551Z",
    fill: "#28673C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_491_3192",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 10,
    width: 9,
    height: 10
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M89.995 10.8349H81.4271V19.4976H89.995V10.8349Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_491_3192)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.6466 13.1162H87.7571V17.2267H83.6466V13.1162ZM83.5408 10.9551H89.9146V19.3879H87.7535C87.7608 18.7015 87.7535 18.0189 87.7279 17.3326C87.0526 18.0079 86.3772 18.6869 85.6982 19.3623C84.2928 19.3879 82.8873 19.3988 81.4855 19.3879C81.4782 17.2632 81.4855 15.1349 81.511 13.0103C82.1973 12.3313 82.8727 11.645 83.5408 10.9551Z",
    fill: "#28673C"
  })))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7475 41.9649V33.9267H0.00460052V32.5679H7.25551V33.9267H4.51261V41.9649H2.7475Z",
    fill: "#28673C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1857 42.0919C7.58567 42.0919 6.64597 40.8601 6.64597 38.7775C6.64597 36.695 7.58567 35.4632 9.1857 35.4632C10.6079 35.4632 11.4587 36.3267 11.4587 37.7744H11.4841V35.5902H13.1604V41.9649H11.4841V39.768H11.4587C11.4587 41.2284 10.6079 42.0919 9.1857 42.0919ZM8.36029 38.7775C8.36029 40.022 8.94442 40.7458 9.96031 40.7458C10.9762 40.7458 11.573 39.9458 11.573 38.7775C11.573 37.5966 10.9762 36.7966 9.96031 36.7966C8.94442 36.7966 8.36029 37.5331 8.36029 38.7775Z",
    fill: "#28673C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3086 41.9649L16.5276 38.7141H16.5022V41.9649H14.826V32.187H16.5022V38.5871H16.5276L19.0927 35.5902H21.0737L18.3689 38.6252L21.3657 41.9649H19.3086Z",
    fill: "#28673C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6014 42.0919C22.6331 42.0919 21.4522 40.8601 21.4522 38.7775C21.4522 36.6823 22.6331 35.4632 24.6014 35.4632C26.557 35.4632 27.7253 36.6823 27.7253 38.7775V38.968H23.0776C23.1411 40.1363 23.6998 40.822 24.6014 40.822C25.3887 40.822 25.9348 40.3903 26.0998 39.6918H27.7253C27.484 41.203 26.3284 42.0919 24.6014 42.0919ZM23.0903 38.3966H26.0872C25.9856 37.3426 25.4395 36.7331 24.6014 36.7331C23.7506 36.7331 23.2046 37.3426 23.0903 38.3966Z",
    fill: "#28673C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2477 41.9649L34.9747 38.2315H33.3366L30.6699 32.5679H32.6889L35.1779 38.0791H35.2033L37.6795 32.5679H39.5843L35.1398 41.9649H33.2477Z",
    fill: "#28673C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.277 42.0919C40.1944 42.0919 38.95 40.8601 38.95 38.7775C38.95 36.695 40.1944 35.4632 42.277 35.4632C44.3596 35.4632 45.5913 36.695 45.5913 38.7775C45.5913 40.8601 44.3596 42.0919 42.277 42.0919ZM42.277 40.7458C43.2929 40.7458 43.8897 40.022 43.8897 38.7775C43.8897 37.5331 43.2929 36.7966 42.277 36.7966C41.2611 36.7966 40.6643 37.5331 40.6643 38.7775C40.6643 40.022 41.2611 40.7458 42.277 40.7458Z",
    fill: "#28673C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0153 42.0919C47.6438 42.0919 46.8438 41.1268 46.8438 39.476V35.5902H48.52V39.3998C48.52 40.2633 48.9518 40.7585 49.701 40.7585C50.5391 40.7585 51.0344 40.1236 51.0344 39.0315V35.5902H52.7106V41.9649H51.0344V39.7172H51.009C51.009 41.203 50.2598 42.0919 49.0153 42.0919Z",
    fill: "#28673C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0489 39.0823V41.9649H54.3727V35.5902H56.0489V38.2188H56.0743C56.0743 36.4791 56.7854 35.4632 57.9918 35.4632C58.3601 35.4632 58.7156 35.5394 58.9823 35.6664L58.4871 37.1648C58.2458 37.0251 57.9156 36.9362 57.5982 36.9362C56.6204 36.9362 56.0489 37.7363 56.0489 39.0823Z",
    fill: "#28673C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7392 42.0919C63.4788 42.0919 62.0439 40.8347 61.8661 38.676H63.5931C63.7074 39.9458 64.5074 40.6823 65.7646 40.6823C67.0598 40.6823 67.809 40.1617 67.809 39.2728C67.809 38.1807 66.6916 38.0156 65.4598 37.8251C63.9106 37.6093 62.1201 37.3426 62.1201 35.2727C62.1201 33.4314 63.4661 32.4409 65.7392 32.4409C67.8217 32.4409 69.1551 33.66 69.3329 35.7172H67.5932C67.517 34.5362 66.8058 33.8505 65.6503 33.8505C64.5455 33.8505 63.8979 34.3203 63.8979 35.133C63.8979 36.06 64.9264 36.2251 66.1074 36.4029C67.6947 36.6442 69.5995 36.9235 69.5995 39.095C69.5995 40.9744 68.1646 42.0919 65.7392 42.0919Z",
    fill: "#28673C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7093 42.0919C71.741 42.0919 70.5601 40.8601 70.5601 38.7775C70.5601 36.6823 71.741 35.4632 73.7093 35.4632C75.6649 35.4632 76.8332 36.6823 76.8332 38.7775V38.968H72.1855C72.249 40.1363 72.8077 40.822 73.7093 40.822C74.4966 40.822 75.0427 40.3903 75.2078 39.6918H76.8332C76.5919 41.203 75.4363 42.0919 73.7093 42.0919ZM72.1982 38.3966H75.1951C75.0935 37.3426 74.5474 36.7331 73.7093 36.7331C72.8585 36.7331 72.3125 37.3426 72.1982 38.3966Z",
    fill: "#28673C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.355 42.0919C78.7549 42.0919 77.8152 40.8601 77.8152 38.7775C77.8152 36.695 78.7549 35.4632 80.355 35.4632C81.7772 35.4632 82.628 36.3267 82.628 37.7744H82.6534V35.5902H84.3296V41.9649H82.6534V39.768H82.628C82.628 41.2284 81.7772 42.0919 80.355 42.0919ZM79.5295 38.7775C79.5295 40.022 80.1137 40.7458 81.1296 40.7458C82.1455 40.7458 82.7423 39.9458 82.7423 38.7775C82.7423 37.5966 82.1455 36.7966 81.1296 36.7966C80.1137 36.7966 79.5295 37.5331 79.5295 38.7775Z",
    fill: "#28673C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4969 42.0919C87.1381 42.0919 86.3381 41.33 86.3381 40.0347V36.7458H85.4238V35.5902H86.4397V33.4568H88.1159V33.9902C88.1159 34.8029 87.5064 35.3743 86.4905 35.5648V35.5902H89.9953V36.7458H88.0143V39.8188C88.0143 40.403 88.3826 40.7458 89.0302 40.7458C89.335 40.7458 89.6524 40.6696 89.881 40.5427V41.7998C89.5 41.9776 88.9794 42.0919 88.4969 42.0919Z",
    fill: "#28673C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_491_3192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.9899,
    height: 25.47,
    fill: "white",
    transform: "translate(0.00497437)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fb2eaeb46f129f554dc21b2ad98d88f5.svg";
export { ForwardRef as ReactComponent };